import ModelValidator from "../validation/validators/ModelValidator";

export default {
    data       : () => ({
        v__isValidatable: true,
        v__validationId : null
    }),
    methods    : {
        v__hasError(attr) {
            return this.v__context?.errors.some(e => e.attr === attr || !attr);
        },
        v__getErrors(attr) {
            return this.v__context?.errors.filter(e => e.attr === attr || !attr).map(e => e.message);
        },
        addErrors(errors) {
            this.$store.commit('validation/add_errors', {
                id: this.v__validationId,
                errors
            });
        },
        clearErrors() {
            this.$store.commit('validation/clear_errors', {id: this.v__validationId});
        },
        async withValidation(config) {
            if(config.validationId){
                this.v__validationId = config.validationId;
            }else {
                config.validator = new ModelValidator(config.rules);
                this.v__validationId = await this.$store.dispatch('validation/add_validator', config);
            }
        },
        async validate(attrs) {
            await this.clearErrors();
            const validationResult = this.v__context.validator.validate(this.v__model, attrs);
            if (!validationResult.valid) {
                this.addErrors(validationResult.errors);
            }
            return validationResult.valid;
        },
        self(){
            return this;
        }
    }, computed: {
        v__context() {
            return this.$store.state.validation.validators.find(v => v.id === this.v__validationId);
        },
        v__model() {
            return this.v__context?.getModel();
        }
    }
}
